import { APP_INITIALIZER, NgModule } from '@angular/core';

import { PerformanceService } from './services/performance.service';

@NgModule({
    imports: [],
    declarations: [],
    bootstrap: [],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (perfService: PerformanceService) => () => perfService.init(),
            deps: [PerformanceService],
            multi: true,
        },
    ],
    exports: [],
})
export class EcmTrackerModule {}
